/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Operazione } from './operazione';


export interface Aggiornamento { 
    id?: string;
    actor_type?: AggiornamentoActorTypeEnum;
    data_operazione?: string;
    commento_operatore?: string;
    operazioni?: Array<Operazione>;
}
export enum AggiornamentoActorTypeEnum {
    CITTADINO = 'CITTADINO',
    OPERATORE = 'OPERATORE',
    SISTEMA = 'SISTEMA',
    ESTERNO = 'ESTERNO',
    CASSIERE = 'CASSIERE',
    ESERCENTE = 'ESERCENTE'
};



